import TextImageSharedComponent from "@components/severalbrands/homePage/firstSection/textImageSharedComponent";
import StrategicLeadGeneration, { ListEl } from "./strategicLeadGeneration";
import { JSONValue } from "@lib/shared/types";
const maximizingConnections = {
    img: "/severalbrands/assets/images/torts.webp",
    mainTitle: "Get Results with Performance-Based Lead Generation",
    paragraphs: [
        "Companies that outsource lead generation experience a 43% increase in their sales pipeline due to specialized expertise and focused strategies. We offer comprehensive digital marketing solutions beyond SEM, SEO, and digital ads, including content marketing, social media strategies, and email campaigns tailored to your unique needs.",
        "Our performance-based model means you only pay for the results we deliver—no leads, no cost—tying your investment directly to tangible outcomes. We provide flexible partnership options, such as form leads, calls, clicks, warm transfers, sales, and scheduled appointments, allowing you to choose the best approach for your business goals. With our fast onboarding process, you can start generating leads and boosting sales immediately.",
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Schedule a Call",
};

export default function GeneralCategorySecondSection({
    mainData,
}: {
    mainData?: {
        imgTextComponentContent?: {
            img: string | JSONValue;
            mainTitle: string;
            paragraphs: string[];
            showAnimation: boolean;
        };
        strategicLeadGenerationContent?: {
            title?: string;
            topDescription?: string;
            bottomDescription?: string;
            list?: ListEl[];
        };
        hideStrategicLeadGenerationContent?: boolean;
    };
}) {
    return (
        <section>
            <div className="3xl:mt-52 lg:mt-40 mt-20">
                <TextImageSharedComponent
                    info={{
                        ...(mainData?.imgTextComponentContent
                            ? mainData?.imgTextComponentContent
                            : maximizingConnections),
                        mainTitleClassName:
                            "font-bold lg:text-6xl text-3xl lg:leading-[79px] 3xl:text-7xl 3xl:leading-[5.5rem] text-[#351C4F]",
                    }}
                />
            </div>
            {!mainData?.hideStrategicLeadGenerationContent && (
                <StrategicLeadGeneration
                    mainData={mainData?.strategicLeadGenerationContent}
                />
            )}
        </section>
    );
}
